<template>
  <form :id="widgetType" @submit.prevent="addNewWidget">
    <label for="" class="form-label">Nombre de Variable</label>
    <input required
      class="form-control"
      v-model="widgetConfig.variableFullName"
      label="Nombre de variable"
      type="text"
    />

    <div>
      <label for="" class="form-label">ID Variable (MQTT)</label>
      <input
        class="form-control"
        v-model="widgetConfig.variable"
        type="text"
      />
    </div>

    <label for="" class="form-label">Icono</label>
    <IconsForm :value="widgetConfig" ></IconsForm>

    <label for="" class="form-label">Frecuencia de Envio</label>
    <input required
      class="form-control"
      v-model="widgetConfig.variableSendFreq"
      label="Frecuencia de Envio"
      type="text"
    />

    <label for="" class="form-label">Seleccionar Color</label>
    <select
      v-model="widgetConfig.class"
      class="form-select"
      placeholder="Select Color"
      label="Seleccionar Color"
      style="width: 100%"
    >
      <option class="text-success" value="success" label="Success"></option>
      <option class="text-primary" value="primary" label="Primary"></option>
      <option class="text-warning" value="warning" label="Warning"></option>
      <option class="text-danger" value="danger" label="Danger"></option>
    </select>

    <label for="" class="form-label">Seleccionar Tamaño</label>
    <select
      v-model="widgetConfig.column"
      class="form-select"
      placeholder="Seleccionar Tamaño"
      style="width: 100%"
      required
    >
      <option value="col-md-3 col-sm-12" label="Pequeño"></option>

      <option value="col-md-6 col-sm-12" label="Mediano"></option>

      <option value="col-12" label="Grande"></option>
    </select>
  </form>
</template>
<script>
import IconsForm from './IconsForm.vue';
import CommunInputs from './common/CommunInputs.vue';
export default {
  props: ["widgetConfig", "addNewWidget", "validateCount","widgetType"],
  components:{
    IconsForm
  }
}

</script>
